// Author Liang Gang Qiang
// Date 2021-10-15 09:54:24

class ImfMstShiftTime {
constructor({
        id = null,
        name = '',
        startTime = '',
        endTime = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.startTime = startTime;
    this.endTime = endTime;
    this.remark = remark;
}
}

function newEntity() {
return new ImfMstShiftTime();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.imfMstShiftTime.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.imfMstShiftTime.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'startTime',
        label: 'label.em.admin.imfMstShiftTime.grid.startTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'endTime',
        label: 'label.em.admin.imfMstShiftTime.grid.endTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstShiftTime.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.admin.imfMstShiftTime.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.admin.imfMstShiftTime.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'startTime',
        label: 'label.em.admin.imfMstShiftTime.entity.startTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
            ,required: true
                }
        },
        {
        key: 'endTime',
        label: 'label.em.admin.imfMstShiftTime.entity.endTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstShiftTime.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {ImfMstShiftTime, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
